import * as React from 'react';
import i18n from 'i18n-react';
import PropTypes from 'prop-types';
/* eslint-disable */
import { Row, Col } from 'antd';
import * as moment from 'moment';
import FlightInfoTime from '../flightInfoTime/FlightInfoTime';
import AirlineCompanyLogo from '../../../../components/airlineCompanyLogo/AirlineCompanyLogo';
import './FlightDetail.css';
import './FlightDetailBaggage.css';
import { isPassengerSplited } from '../../../../services/detail/PnrToPnrItemModelAssembler';

const propTypes = {
  data: PropTypes.any
};

function FlightDetail(props) {
  const hasEmdServices = props.data.emdServices != null && props.data.emdServices.length > 0 ? showEMDService(props.data) : null;
  return (
    <div className="FlightDetail margin-eight-left-24">
      {renderFlight(props.data, false)}
      {renderArrivalFlight(props.data)}
      {hasEmdServices}
    </div>
  );
}

function renderArrivalFlight(data) {
  return data.cart.items[0].returnFlight ? renderFlight(data, true) : <div />;
}

function renderFlight(data, isReturnFlight) {
  const flight = isReturnFlight
    ? data.cart.items[0].returnFlight
    : data.cart.items[0].departureFlight;
  return (
    <div data-test={isReturnFlight ? 'containerFlightReturn' : 'containerFlightDeparture'}>
      <Row className={`FlightDetail__flightHeader--${isReturnFlight ? 'return' : 'departure'} `}>
        <Col span={24} className="text-l text-science-blue">
          {renderFlightTitle(
            flight.originAirportName,
            flight.finalDestinationName,
            flight.departureDate,
            isReturnFlight
          )}
        </Col>
      </Row>
      <div className={`FlightDetail__${isReturnFlight ? 'return' : 'departure'}Flights`}>
        {renderFlightConnections(flight.flightGroup, false)}
      </div>
      <div className={`FlightDetail__${isReturnFlight ? 'return' : 'departure'}Passengers`}>
        <Row>
          <Col span={24} className="FlightDetail__passengers__title" />
        </Row>
        <Row className="FlightDetail__passengersContent">
          {renderFlightPassengers(data.passengers, flight.baggage,data)}          
        </Row>
      </div>
    </div>
  );
}

function showEMDService(data) {
	return (
		<div data-test={'containerFlightDeparture'}>
			<Row className='FlightDetail__passengersContent'>
				{renderEMDServices(data.passengers, data.emdServices)}
			</Row>
		</div>
	)
}

function renderFlightTitle(departureAirport, arrivalAirport, departureDate, isReturnFlight) {
  const title = (
    <div>
      <span>{departureAirport}</span>
      <span className="departureToOrigin">{` ${i18n.translate('features.flightInfo.to')} `}</span>
      <span>{arrivalAirport}</span>
    </div>
  );  
  
  return (
    <div>
      <Row>
        <Col span={4} className="FlightDetail__title">
          {!isReturnFlight
            ? i18n.translate('features.flightInfo.departure')
            : i18n.translate('features.flightInfo.arrival')}
        </Col>
        <Col
          span={20}
          className="FlightDetail__date text-silver text-300"
          data-test="departureDate">          
          {moment(departureDate, 'DD/MM/YYYY')
            .locale('America/Sao_Paulo')
            .format('ddd, D MMM YYYY')}
        </Col>
      </Row>
      <Row>
        <Col
          span={24}
          className="FlightDetail__airports text-dark-blue text-300 padding-eight-top-8"
          data-test="titleJourney">
          {title}
        </Col>
      </Row>
    </div>
  );
}

function renderFlightConnections(flightGroup, isReturnFlight) {
  return (
    <div className="FlightDetail__flightConnections margin-eight-top-32">
      {flightGroup &&
        flightGroup.map((flight, index) => {
          return (
            <div key={index}>
              <Row>
                <Col span={11}>
                  <FlightInfoTime
                    flightGroup={flightGroup}
                    hasAirportChange={false}                    
                    hideConnectionLine={true}
                    isDepartureFlight={!isReturnFlight}
                    background="white"
                    departureFlight={{
                      time: flight.departureTime,
                      airportSign: flight.origin
                    }}
                    arrivalFlight={{
                      plusDays: flight.dateVariation,
                      time: flight.arrivalTime,
                      airportSign: flight.destination
                    }}
                  />
                </Col>
                <Col
                  className="FlightDetail__flightNumber text-md"
                  span={4}
                  data-test="operatingCarrierAndFlightNumber">
                  <Row className="FlightDetail__carrierSpacing">
                    {i18n.translate('features.flightInfoTime.operatedBy')}{' '}
                    {getOperatingCarrierName(flight.operatingCarrier)}
                  </Row>
                  <Row className="FlightDetail__carrierSpacing">
                    {i18n.translate('features.flightInfoTime.flight')} {flight.operatingCarrier}{' '}
                    {flight.flightNumber}
                  </Row>
                </Col>
                <Col span={5} className="FlightDetail__airCompanyLogo">
                  <AirlineCompanyLogo flights={[flight]} />
                </Col>
                <Col
                  span={4}
                  className="FlightDetail__cabin text-md text-center text-silver"
                  data-test="flightCategory">
                  {getCabin(flight.cabinCategory)}
                </Col>
              </Row>
              {renderStopLabelRow(flightGroup, index)}
            </div>
          );
        })}
    </div>
  );
}

function getOperatingCarrierName(operatingCarrier) {
  if (
    i18n
      .translate(`company.${operatingCarrier}`)
      .toString()
      .substring(0, 8) === 'company.'
  ) {
    return operatingCarrier;
  } else {
    return i18n.translate('company.' + operatingCarrier);
  }
}

function renderFlightPassengers(passengers, baggage,data) {
  return (
    <div className="margin-eight-top-40 text-md">
      <Row>
        <Col span={5} className="text-500 text-dark-blue">        
          {i18n.translate('features.flightDetails.passengers')}
        </Col>
        <Col span={5} className="text-500 text-dark-blue">
          {i18n.translate('features.flightDetails.ticketNumber')}
        </Col>
        <Col span={5} className="text-500 text-dark-blue">        
          {i18n.translate('features.flightDetails.bag')}
        </Col>
        <Col span={5} className="text-500 text-dark-blue">
					{i18n.translate('') }
				</Col>        
      </Row>
      {passengers.map((passenger, index) => {        
        return (
          <Row className={`FlightDetail__passenger--${index} text-warm-grey-two`} key={index}>
            <Col className="FlightDetail__passengerName" span={5} data-test="passengerName">
              {passenger.name} {passenger.lastName}
            </Col>
            <Col className="FlightDetail__passengerTicket" span={5} data-test="passengerTicket">
              {passenger.ticketNumber}
            </Col>            
            <Col className={`FlightDetailBaggage__description ${getMsgBaggage(baggage).color}`}  span={5} data-test="passengerBag">
              {getMsgBaggage(baggage).msg}
            </Col>
            <Col className="text-500 text-dark-blue" span={6}>
							{renderInfoPassengerSplitPnr(passenger, data)}
						</Col>            
          </Row>
        );
      })}
    </div>
  );
}

function getMsgBaggage(baggage) {
  let baggage_color, message;
  const GREEN_COLOR = 'green';
  const RED_COLOR = 'red';
  if (baggage.quantity > 0 || baggage.weight > 0) {
    baggage_color = GREEN_COLOR;
    if (baggage.weight > 0) {
      message = i18n.translate('features.baggage.weight', {
        weight: baggage.weight
      });
    } else if (baggage.quantity && baggage.quantity > 1) {
      message = i18n.translate('features.baggage.quantity.many', {
        quantity: baggage.quantity
      });
    } else {
      message = i18n.translate('features.baggage.quantity.single');
    }
  } else {
    baggage_color = RED_COLOR;
    message = i18n.translate('features.baggage.notIncluded');
  }
  return {
    msg: message,
    color: baggage_color
  };
}

function renderInfoPassengerSplitPnr(passenger, pnr) {
	let retorno = "";
   if (pnr.pnrSplit.pnrChild && pnr.pnrSplit.pnrChild.length > 0) {
		pnr.pnrSplit.pnrChild.map((pnrChild) => {
			pnrChild.forEach((splitChild) => {
				if(isPassengerSplited(pnr,passenger)){
					retorno = i18n.translate('features.flightDetails.splitPassenger.msgPassengerSendplit', {
						pnrCode: splitChild.pnrCode }).toString()
				}
			})
		})
	}	
  if (retorno === "" && pnr.pnrSplit.pnrParent) {		
    retorno = i18n.translate('features.flightDetails.splitPassenger.msgPassengerReceivedSplit', {
              pnrCode: pnr.pnrSplit.pnrParent.pnrCode }).toString() 
	} 
	return retorno;
}

function renderStopLabelRow(flightGroup, index) {
  if (flightGroup.length - 1 !== index && flightGroup[index + 1]) {
    return (
      <Row className="FlightDetail__stopsLineContainer" data-test="technicalStop">
        <Col span={24} className="FlightDetail__stopsLineContainer--line">
          <span
            className={`FlightDetail__stopsLineContainer--label text-warm-grey text-sm bg-white
							${flightGroup[index + 1].hasExchangeAirport ? 'text-red' : ''}
						`}>
            {getStopLabel(flightGroup[index + 1], index, flightGroup)}
          </span>
        </Col>
      </Row>
    );
  }
}

function getCabin(cabin) {
  return cabin.toString().toUpperCase() !== 'C'
    ? i18n.translate('features.flightInfo.cabinEconomy')
    : i18n.translate('features.flightInfo.cabinBusiness');
}

function getStopLabel(flight, index, flightGroup) {
  if (flight.hasExchangeAirport) {
    return `${i18n.translate(verifyOriginAirportNameAndDestinationAirportName(flightGroup, index),
      {time: calculateWaitingTimes(flightGroup, index)})}`;
  } else if (flight.throughFlight) {
    return `${i18n.translate('components.resume.messageConnection',
      {time: calculateWaitingTimes(flightGroup, index)})}`;
  } else {
    return `${i18n.translate('components.resume.messageEscale',
      {time: calculateWaitingTimes(flightGroup, index).toString()})}`;
  }
}

function verifyOriginAirportNameAndDestinationAirportName(flightgroup, index) {
  const departureAirport = flightgroup[index].destination;
  const arrivalAirport = index === 0 ? flightgroup[index].destination : flightgroup[index + 1].origin;
  let result = '';

  arrivalAirport == departureAirport 
  ? result = 'components.flightDetailsModal.messageAirplaneChange'
  : result = 'components.flightDetailsModal.messageAirportChange';
   
  return result;
}

function calculateWaitingTimes(flightGroup, index) {
    const format = 'HH:mm';
    const waitingTimes = [];

    for (let i = 0; i < flightGroup.length - 1; i++) {
      const arrivalTime = moment(flightGroup[i].arrivalTime, format);
      const nextDepartureTime = moment(flightGroup[i + 1].departureTime, format);

      let waitingTime = moment.duration(nextDepartureTime.diff(arrivalTime));

      if (waitingTime.asMinutes() < 0) {
        waitingTime = moment.duration(nextDepartureTime.add(1, 'day').diff(arrivalTime));
      }

      const hours = Math.floor(waitingTime.asHours());
      const minutes = waitingTime.minutes();

      if (hours === 0) {
        waitingTimes.push(`${minutes}min`);
      } else {
        waitingTimes.push(`${hours}h ${minutes}min`);
      }
    }

    return waitingTimes[index];
}

function renderEMDServices(passengers, services) {
  return (
		<div className="margin-eight-top-40 text-md">
			<Row>
				<Col sm={1} className='FlightDetail__Logo'>
					<div className="FlightDetail__infoLogo" />
				</Col>
				<Col span={6} className="FlightDetail__LogoText">
					{i18n.translate('features.flightDetails.textEmdServices')}
				</Col>
			</Row>
			<Row>
				<Col span={5} className="text-500 text-dark-blue">
					{i18n.translate('features.flightDetails.passengers')}
				</Col>
				<Col span={6} className="text-500 text-dark-blue">
					{i18n.translate('features.flightDetails.emdTicketNumber')}
				</Col>
				<Col span={6} className="text-500 text-dark-blue">
					{i18n.translate('features.flightDetails.textEmdTypeService')}
				</Col>
			</Row>
			{services.map((service, index) => {
				let passenger = passengers.find((element) => element.ticketNumber == formatTicketNumber(service.ticket))
				const map = new Map(Object.entries(service.serviceMap))
				let rows = new Array()
				map.forEach((value, key, map) => rows.push(renderServiceMap(passenger,key,value,index)))
				return(
					<div>
            {rows.map((value) => <div>{value}</div>)}
					</div>
				);
			})}
		</div>
	);
}

function renderServiceMap(passenger, key, value, index) {
	return(
		<Row className={`FlightDetail__passenger--${index} text-warm-grey-two`} key={index}>
			<Col className="FlightDetail__passengerName" span={5} data-test="passengerName">
				{passenger.name} {passenger.lastName}
			</Col>
			<Col className="FlightDetail__passengerTicket" span={6} data-test="passengerTicket">
				{key}
			</Col>
			<Col>
				{value}
			</Col>
		</Row>
	);
}

function formatTicketNumber(ticket){
	return "PAX " + ticket.slice(0,3) + "-" + ticket.slice(3,ticket.length);
}

FlightDetail.propTypes = propTypes;

export default FlightDetail;



// WEBPACK FOOTER //
// ./src/page/flightDetailsPage/components/flightDetail/FlightDetail.jsx